import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import LoginPage from "./pages/LoginPage";
import { UserProvider } from "./contexts/UserContext";

export default function App() {
  return (
    <Router>
      <Layout>
        <UserProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/project/:id" element={<ProjectDetailsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
        </Routes></UserProvider>
      </Layout>
    </Router>
  );
}
